import { gql } from '@apollo/client';

export const DiscountSummaryFragment = gql`
    fragment DiscountSummaryFragment on CartPrices {
        discounts {
            amount {
                currency
                value
            }
            label
        }
    }
`;

import React from 'react';
export default function Stub() { return null; }
